var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterPrivacyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02631 17.7549C6.39563 18.8317 8.12283 19.474 9.99999 19.474C11.8771 19.474 13.6043 18.8317 14.9737 17.7549",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63154 3.72266C4.34005 4.73402 1.94733 7.79829 1.94733 11.4214C1.94733 12.3331 2.09885 13.2095 2.37809 14.0266",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3683 3.72266C15.6598 4.73402 18.0526 7.79829 18.0526 11.4214C18.0526 12.3331 17.901 13.2095 17.6218 14.0266",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.1575C19 16.793 18.7497 17.37 18.3424 17.7953C17.9113 18.2456 17.3042 18.5259 16.6316 18.5259C15.3236 18.5259 14.2632 17.4655 14.2632 16.1575C14.2632 15.2053 14.825 14.3844 15.6353 14.0082C15.9381 13.8676 16.2757 13.7891 16.6316 13.7891C17.9396 13.7891 19 14.8495 19 16.1575Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73684 16.1575C5.73684 16.793 5.48655 17.37 5.07922 17.7953C4.64808 18.2456 4.041 18.5259 3.36842 18.5259C2.06038 18.5259 1 17.4655 1 16.1575C1 15.2053 1.56186 14.3844 2.37211 14.0082C2.67497 13.8676 3.01253 13.7891 3.36842 13.7891C4.67645 13.7891 5.73684 14.8495 5.73684 16.1575Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3685 3.36842C12.3685 4.00391 12.1182 4.58091 11.7109 5.00628C11.2797 5.45651 10.6727 5.73684 10.0001 5.73684C8.69204 5.73684 7.63165 4.67645 7.63165 3.36842C7.63165 2.41627 8.19349 1.59535 9.00377 1.21913C9.3066 1.0785 9.64419 1 10.0001 1C11.3081 1 12.3685 2.06038 12.3685 3.36842Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPrivacyCircle);
export default __webpack_public_path__ + "static/media/filter-privacy-circle.338b6063affd313d86a813302ffee819.svg";
export { ForwardRef as ReactComponent };